export default __webpack_public_path__ + "79a20a339475aad1e207ed4d2e16c30b.jpg";